import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../services/firebase"; // adjust path as needed
import GoogleGIcon from '../GoogleGIcon'

import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import SimpleAuthNavbar from '../SimpleAuthNavbar'
// import AuthNavbar from "../navbars/AuthNavbar";



function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authError, setAuthError] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isGoogleSigningIn, setIsGoogleSigningIn] = useState(false);

  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        navigate("/home");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);
    setAuthError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/home");
    } catch (error) {
      console.error("Login error:", error);
      switch (error.code) {
        case "auth/user-not-found":
          setAuthError("No user found with this email.");
          break;
        case "auth/wrong-password":
          setAuthError("Incorrect password.");
          break;
        case "auth/invalid-email":
          setAuthError("Invalid email address.");
          break;
        default:
          setAuthError("Login failed. Please try again.");
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setAuthError(null);
    setIsGoogleSigningIn(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      // Optional: welcome toast
      // alert(`Welcome ${result.user.displayName || "back"}!`);
      navigate("/home");
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      if (error.code === "auth/popup-closed-by-user") {
        setAuthError("The sign-in popup was closed before completing the sign in.");
      } else if (error.code === "auth/cancelled-popup-request") {
        setAuthError("Another popup request was cancelled. Please try again.");
      } else if (error.code === "auth/account-exists-with-different-credential") {
        setAuthError(
          "This email is already used with a different sign-in method. Try logging in with your email and password, then link Google in your profile."
        );
      } else {
        setAuthError("Google Sign-In failed. Please try again.");
      }
    } finally {
      setIsGoogleSigningIn(false);
    }
  };

  return (
    <>
      <SimpleAuthNavbar />
      <div className="navbarmargin mt-4"></div>

      <Container style={{ maxWidth: "500px" }}>
        <h2 className="text-center mt-4">Login</h2>

        {state?.msg && <Alert variant="warning">{state.msg}</Alert>}
        {state?.error && <Alert variant="danger">{state.error}</Alert>}
        {authError && (
          <Alert variant="danger" role="alert" aria-live="assertive">
            {authError}
          </Alert>
        )}

        {/* Email/Password Login */}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={isLoggingIn || isGoogleSigningIn}
            aria-disabled={isLoggingIn || isGoogleSigningIn}
          >
            {isLoggingIn && <Spinner as="span" size="sm" className="me-2" />}
            Log In
          </Button>
        </Form>

        <div className="d-flex justify-content-between mt-3">
          <Link to="/auth/register">Don't have an account? Register</Link>
          <Link to="/auth/forgot-password">Forgot password?</Link>
        </div>

        {/* Horizontal Divider (always visible) */}
        <div className="divider my-4">
          <span>OR</span>
        </div>

        {/* Google Sign-In Button */}
        <button
          type="button"
          className="google-btn w-100"
          onClick={handleGoogleSignIn}
          disabled={isGoogleSigningIn || isLoggingIn}
          aria-disabled={isGoogleSigningIn || isLoggingIn}
          aria-label="Sign in with Google"
        >
          {isGoogleSigningIn ? (
            <>
              <Spinner as="span" size="sm" className="me-2" /> Signing in…
            </>
          ) : (
            <>
              <GoogleGIcon className="google-icon" />
              <span>Sign in with Google</span>
            </>
          )}
        </button>

      </Container>
    </>
  );
}






export default LoginPage;